
import WebApi from '../Api/WebApi'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const ObtenerTodos = createAsyncThunk(
    "formas/ObtenerTodos",
    async (i, { rejectWithValue }) => {
        try {
            if(typeof i === 'undefined'){
                const res = await WebApi.api().get(`admin/formas`)
            return res.data.result;
             }
             else{
                const res = await WebApi.api().get(`admin/formas?nombre=${i}`)
                return res.data.result;
             }
        } catch (err) {
            return { success: false, message: err, show: true };
        }
    }
);
export const ObtenerById = createAsyncThunk(
    "formas/ObtenerById",
    async (id, { rejectWithValue }) => {
        try {
            const res = await WebApi.api().get('admin/formas/' + id)
            return res.data.result;
        } catch (err) {
            return { success: false, message: err, show: true };
        }
    }
);
export const Insertar = createAsyncThunk(
    "formas/Insertar",
    async (item, { rejectWithValue }) => {
        try {
            const res = await WebApi.api().post('admin/formas', item)
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
export const Actualizar = createAsyncThunk(
    "formas/Actualizar",
    async (item, { rejectWithValue }) => {
        try {
            const res = await WebApi.api().put('admin/formas/' + item.formaConocernosId, item)
            return res.data
        } catch (err) {
            return rejectWithValue(err)
        }
    }
);
export const Eliminar = createAsyncThunk(
    "formas/Eliminar",
    async (id, { rejectWithValue }) => {
        try {
            const res = await WebApi.api().delete('admin/formas/' + id)
            return res.data
        } catch (err) {
            return rejectWithValue(err)
        }
    }
);



const formasSlice = createSlice({
    name: 'campos',
    initialState: {
        formas: [],
        model: {},
    },
    reducers: {
    },
    extraReducers: {
        [ObtenerTodos.fulfilled]: (state, action) => {
            state.formas = action.payload;
        },
        [ObtenerById.fulfilled]: (state, action) => {
            state.model = action.payload;
        },
    }
})

export default formasSlice.reducer;